import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'uriDecode',
    standalone: false
})
export class UriDecodePipe implements PipeTransform {

  transform(value: string): string {
    return decodeURIComponent(value);
  }

}